import React, { useState } from 'react';
import './createhira.scss';
import { Button, CircularProgress, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import * as hiraService from "../../../services/HiraService";
import BackButton from './../../../components/BackButton/BackButton';
import Swal from 'sweetalert2';

const CreateHira = () => {
  const [lohateny, setLohateny] = useState("");
  const [tonony, setTonony] = useState("");
  const [audio, setAudio] = useState(null); 
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

    const handleSubmit = (e) => {
      e.preventDefault();
  
      setIsLoading(true);
  
      const formData = new FormData();
      formData.append("lohateny", lohateny);
      formData.append("tonony", tonony);
      formData.append("audio", audio);
  
      hiraService.addHira(formData)
        .then((res) => {
          if (res.status === 200) {
            Swal.fire(
              'Chanson créée !',
              'Création de la chanson avec succès',
              'success'
            );
            setTimeout(() => {
              navigate('/hira');
            }, 2000);
          }
        })
        .catch((err) => {
          Swal.fire(
            'Nope',
            'Une erreur s\'est produite',
            'error'
          );
          console.error(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

  return (
    <div>
      <div className="back" style={{margin:"10px 0 0 30px"}}>
        <BackButton />
      </div>

      <div className="addHira">
        <span className='titre'>Nouveau Hira</span>

        <div className='form-hira'>
          <form onSubmit={handleSubmit}>
            <TextField
              type="text"
              label="Lohateny"
              variant="outlined"
              margin='normal'
              multiline
              onChange={(e) => setLohateny(e.target.value)} 
              required
            />
            <TextField
              type="text"
              label="Tonony"
              variant="outlined"
              margin='normal'
              multiline
              onChange={(e) => setTonony(e.target.value)} 
            />
            <TextField
              type="file"
              label="Ajouter une audio"
              variant="outlined"
              margin='normal'
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setAudio(e.target.files[0])} 
              accept="audio/mp3"
              required
            />
            <Button type="submit" variant="contained" disabled={isLoading}>
              {isLoading ? <CircularProgress size={24}/> : "Valider"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateHira;
